<template>   
  <div>
    <v-card flat>      
        <div>
          <v-row no-gutters fill-height>
            <v-expansion-panels
              v-model="panel"
              :disabled="disabled"
              multiple 
              accordion     
            >
              <v-expansion-panel>
                <v-expansion-panel-header>Select Condition</v-expansion-panel-header>
                <v-expansion-panel-content >
                  <!-- =============Start Search Condition============= -->
                      <v-row dense >
                        <!-- From Date -->
                        <v-col
                          class="pl-2"
                          cols="6"
                          sm="6"
                          md="4"
                        >                           
                        <DxDateBox  
                            label="From date"                            
                            :value="stDate" 
                            display-format="yyyy-MM-dd" 
                            :acceptCustomValue="false"
                            @value-changed="e => {stDate = e.value && getStrFormat(e.value)}"
                            dense
                        /> 
                        </v-col>
                        <!-- To date -->
                        <v-col
                          class="pl-2"
                          cols="6"
                          sm="6"
                          md="4"
                        >                           
                        <DxDateBox  
                            label="To date"                            
                            :value="edDate" 
                            display-format="yyyy-MM-dd" 
                            :acceptCustomValue="false"
                            @value-changed="e => {edDate = e.value && getStrFormat(e.value)}"
                            dense
                        />
                        </v-col>                      
                        <!-- Department -->
                        <v-col
                          class="mt-2"
                          cols="6"
                          sm="6"
                          md="4"
                        >
                            <v-select 
                              label="Department"
                              v-model="deptName" 
                              :items="deptNameList" 
                              item-value="deptName" 
                              return-object 
                              outlined 
                              dense
                              @change = "groupList"
                            >
                            </v-select>
                        </v-col>
                        <!-- Group -->
                        <v-col
                          class="mt-2"
                          cols="6"
                          sm="6"
                          md="4"
                        >
                            <v-select 
                              label="Group"
                              v-model="respName" 
                              :items="respNameList" 
                              item-value="respName"
                              return-object
                              outlined 
                              dense
                              
                            >
                            </v-select>
                        </v-col>
                        <!-- Ship No -->
                        <v-col                            
                          class="mt-2"
                          cols="6"
                          sm="6"
                          md="4"
                        >
                            <v-select 
                              label="Ship No"
                              v-model="shipNo" 
                              :items="shipNoList" 
                              return-object 
                              item-value="shipNo" 
                              outlined
                              dense
                            >
                            </v-select>
                        </v-col>
                        <!-- QM Part -->
                        <v-col                            
                          class="mt-2"
                          cols="6"
                          sm="6"
                          md="4"
                        >
                            <v-select 
                              label="QM Part"
                              v-model="qmPartName" 
                              :items="qmPartNameList" 
                              return-object 
                              item-value="qmPartName" 
                              outlined
                              dense
                            >
                            </v-select>
                        </v-col>
                        <!-- Inspection Result -->
                        <v-col class="mt-2"
                          cols="6"
                          sm="6"
                          md="4" >
                            <v-select
                                label="Result Insp."
                                v-model="resultInsp"
                                :items="resultInspList"
                                item-value="insResCd"
                                item-text="insResNm"
                                return-object
                                outlined
                                dense
                            ></v-select>
                        </v-col>
                        <v-col
                          cols="6"
                          sm="6"
                          md="4"
                        >
                          <v-btn 
                          
                            height = "30px"
                            class="mt-2 "
                            block
                            dense
                            color="success"
                            @click="btnRetrieve"
                          >
                            <v-icon left>
                              {{ icons.mdiMapSearch }}
                            </v-icon>
                            Retrieve
                          </v-btn>
                        </v-col>
                      </v-row>
                    <!-- ==========End Search Condition================= -->
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
        </div>
         <!-- Change theme -->
         <v-fab-transition>
          <v-btn
            @click="dark = !dark"
            absolute
            top
            right
            fab
          >
            <v-icon>mdi-invert-colors</v-icon>
          </v-btn>
        </v-fab-transition>
    </v-card> 
    
    <v-card class="mt-2">  
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>  

          <v-data-table
            :mobile-breakpoint="800"
            :mobile="mobile"
            :items-per-page="15"
            :headers="headers"
            :items="gridMainList"
            :search="search"
            :dense="true"
            :sort-by="[]"
            :sort-desc="[false]"
            :dark="dark"
          >
          <!-- v-slot:[`item.rno`]="{item}" -->
            <template  #[`item.rno`]="{item}">
              <v-chip
                :color="getColor(item.rno)"
                :dark="dark"
              >
                {{ item.rno }}
              </v-chip>
            </template>

            <template v-slot:[`item.plans`]="{item}">
              <v-row class="light--text" >
                    <v-checkbox 
                      label="Owner"
                      v-model="item.wowShow"
                      disabled
                      dense
                    ></v-checkbox>
                    <v-checkbox  
                      label="Class"            
                      v-model="item.wclShow"
                      disabled
                      dense
                    ></v-checkbox>
               </v-row>
            </template>

            <template v-slot:[`item.actuals`]="{item}">
              <v-row class="light--text" >
                    <v-checkbox 
                      label="Owner"
                      v-model="item.wowAct"
                      disabled
                      dense
                    ></v-checkbox>
                    <v-checkbox  
                      label="Class"            
                      v-model="item.wclAct"
                      disabled
                      dense
                    ></v-checkbox>
               </v-row>
            </template>
            <!-- QM Input Result -->
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                v-if="autSaveYN==='S'"
                x-small
                class="px-2"
                outlined
                :dark="dark"
                dense
                @click="editItem(item)"
              ><v-icon x-small left >mdi-pencil</v-icon>
                <span x-small>Input data</span>
              </v-btn>

            </template>
            <!-- Owner Result -->
            <template v-slot:[`item.insResCd`]="{ item }" >
             
              <span class="mr-2"  v-if="item.insResCd != null" 
              >{{ item.insResCd }} 
              </span>
              <span v-if="item.insResCd != null && item.insNRes != null" >
                ( {{ item.insNRes }} point )
              </span>

            </template> 

            <!-- Input MH Result -->
            <template v-slot:[`item.mh`]="{ item }">
              <span class="mr-2" 
              >{{ item.mh }} /${{ item.usdAmt }}</span>             

            </template>

            <!-- Dialog  Input Result -->  
            <template v-slot:top>
              <v-dialog
                v-model="dialog"
                max-width="90%"
                persistent
                transition="dialog-bottom-transition"
              >
                
                <v-card :dark="dark">
                  <v-card-title>
                    <span class="text-h5">{{titleInput}}</span>
                  </v-card-title>
      
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                          v-if="autDept === 'Y'"
                        >
                        <v-select
                          v-model="inputResult.insResCd" 
                          :items="resultInspList"
                          item-value="insResCd"
                          item-text="insResNm"
                          label="Owner*"
                          required
                          :disabled="disabledOwner"
                          @change="changeSelect(inputResult)"
                        ></v-select>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                          v-if="autDept === 'Y'"
                        > 
                          <v-select
                            v-model="inputResult.insResDe" 
                            :items="resultInspDeList"
                            item-value="insResDe"
                            item-text="insResDeNm"
                            label="Delegation*"
                            required
                            :disabled="disabledDel"
                            
                          ></v-select>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                          v-if="autDept === 'Y'"
                        > 
                          <v-select
                            v-model="inputResult.resPaintMK" 
                            :items="resultInspPaintMKList"
                            item-value="resPaintMK"
                            item-text="resPaintMKNm"
                            label="Maker*"
                            required
                            :disabled="disabledMaker"
                          ></v-select>
                        </v-col>
                       
                        <v-col
                          cols="6"
                          sm="6"
                          md="4"
                          v-if="autDept === 'Y'"
                        >
                          <v-checkbox
                            v-model="inputResult.wowAct"
                            label="Owner Actual"
                            color="red"
                            hide-details
                          ></v-checkbox>
                        </v-col>

                        <v-col
                          cols="6"
                          sm="6"
                          md="4"
                          v-if="autDept === 'Y'"
                        >
                          <v-checkbox
                            v-model="inputResult.wclAct"
                            label="Class Actual"
                            color="indigo"
                            hide-details
                          ></v-checkbox>
                        </v-col>

                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                        >
                          <v-text-field
                            v-model="inputResult.mh"
                            label="M/H reject"
                            :disabled="disabledMh"
                          ></v-text-field>
                        </v-col>
                        
                      </v-row>
                    </v-container>
                  </v-card-text>

                  
      
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="closeResult"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="saveResult(inputResult)"
                    >
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template> 
   
          </v-data-table> 

          <!-- Snackbar Dialog -->
          <v-snackbar
            v-model="snack"
            :timeout="3000"
            :color="snackColor"
          >
            {{ snackText }}
      
            <template v-slot:action="{ attrs }">
              <v-btn
                v-bind="attrs"
                text
                @click="snack = false"
              >
                Close
              </v-btn>
            </template>
          </v-snackbar>              
    </v-card>
    <!-- Scroll To Top -->
    <v-btn
      v-scroll="onScroll"
      v-show="fab"
      fab
      dark
      fixed
      bottom
      right
      color="primary"
      @click="toTop"
    >
      <v-icon>mdi-chevron-up</v-icon>
    </v-btn>
   
  </div>  
</template>

<script>
import  {
        mdiAccount,
        mdiPencil,
        mdiShareVariant,
        mdiDelete,
        mdiSelectSearch,
        mdiMapSearch 

      } from '@mdi/js'

import  { getShipList, 
          getDeptList,
          getRespList,
          getQMPartList,
          getResultList
      } from '@/api/view/tqm/80/v80comm.js'

import  {
        getAutSaveYN,
        getAutInspection,
        getInsResultChk,
        getInsResultChkDel,
        getShipIncharge,
        getCloseYN,
        getEvalPoint,
        v80b1020List,
        v80b1020Update,
      } from '@/api/view/tqm/80/v80b1020.js'

import DxDateBox from 'devextreme-vue/date-box'
import baseview from '@/components/base/baseview.vue' // base page addition
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // Add base when using data grid

import {
getDateFormat,
} from '@/utils/common.js'

import dayjs from 'dayjs';
import notify from 'devextreme/ui/notify' // message



export default {
name: "v80b1020",
mixins: [baseview, BaseDataGrid],
data: () => ({
  fab: false,
  dark: false,
  icons: {
    mdiAccount,
    mdiPencil,
    mdiShareVariant,
    mdiDelete,
    mdiSelectSearch,
    mdiMapSearch

  },
  // for Dialog
  dialog: false,
  snack: false,
  snackColor: '',
  snackText: '',
  max25chars: v => v.length <= 25 || 'Input too long!',
  modeIndex: -1,  
  inputResult: {
    insResDe: '',
    resPaintMK: '',
    mh:'',
    insResCd:'', 
    deptCd:'',
    qcYN: '',
    wowAct: false,
    wclAct: false,

  }, 
  insNRes:null,
  // for Search condition
  stDate: '',
  edDate: '',
  shipNoList: [],
  shipNo: '',
  deptName: '',
  deptNameList: [],
  deptCd: '',
  respName: '',
  respNameList: [],
  respCd: '',
  qmPart: '',
  qmPartName:'',
  qmPartNameList: [],
  resultInsp: '',
  resultInspList: [],
  resultInspDe: '',
  resultInspDeList: [],

  resultInspPaintMKList: [],
 
  panel: [0],
  disabled: false,
  hover: true,

  // for Data list
  gridMainList: [],
  listSize: 0,
  
  mobile: true,
  search: '',
  headers: [
              {
                text: 'No',
                align: 'start',
                value: 'rno',
                divider: true,
                sortable: false,
                class:'light-green darken-3 white--text'
              },
              { text: 'Ship No', sortable: false, divider: true,align: 'start',value: 'shipNo',class:'light-green darken-3 white--text' },
              { text: 'Inspection Date',sortable: false, divider: true, align: 'start',value: 'insDateShow',class:'light-green darken-3 white--text', width: '150' },
              { text: 'Actions', sortable: false, divider: true,align: 'start',value: 'actions',class:'light-green darken-3 white--text' },
              { text: 'Owner', sortable: false, divider: true,align: 'start',value: 'insResCd',class:'light-green darken-3 white--text' },
              { text: 'Delegation', sortable: false, divider: true,align: 'start',value: 'insResDe',class:'light-green darken-3 white--text' },
              { text: 'Maker', sortable: false, divider: true,align: 'start',value: 'resPaintMK',class:'light-green darken-3 white--text' },
              { text: 'MH Reject/USD', sortable: false, divider: true,align: 'start',value: 'mh', class:'light-green darken-3 white--text' },
              { text: 'Description', sortable: false, divider: true,align: 'start',value: 'itemDesc2', class:'light-green darken-3 white--text' },
              { text: 'QM part', sortable: false, divider: true,align: 'start',value: 'qmPartNm', class:'light-green darken-3 white--text' },
              { text: 'Kind Inspection', sortable: false, divider: true,align: 'start',value: 'kindNm', class:'light-green darken-3 white--text' },
              { text: 'Location', sortable: false, divider: true,align: 'start',value: 'locNm', class:'light-green darken-3 white--text' },
              { text: 'Dept/group', sortable: false, divider: true,align: 'start',value: 'deptNm', class:'light-green darken-3 white--text' },
              { text: 'Witness Plan', sortable: false, divider: true,align: 'start',value: 'plans', class:'light-green darken-3 white--text' },
              { text: 'Witness Actual', sortable: false, divider: true,align: 'start',value: 'actuals', class:'light-green darken-3 white--text'},
            ],

  autSaveYN:'R',
  autDept:'N',
  autChkSection:{},
  // autKmgrSec:'',
  // autVmgrSec:'',
  // autDimSec:'',
  insResChk: 0,
  insResChkDel: 'N',
  shipIncharge: 0,
  clsYn:'N', 
  disabledOwner: false,
  disabledDel: false,
  disabledMaker: false,
  disabledMh: false, 
  titleInput: '',

}),
components: {
  DxDateBox,
  // AppButton,
},

computed: {
  },

  watch: {
    /*  options: {
    handler () {
      this.btnRetrieve()
    },
    deep: true,
  }, */
  },

  mounted() {
    this.init()
   
  },
  methods: {
    onScroll (e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset ||   e.target.scrollTop || 0
      this.fab = top > 20
    },
    toTop () {
      this.$vuetify.goTo(0)
    },
    
    btnRetrieve() {
        this.gridMainList = []        
        this.getMainList()
        
    },
    getStrFormat(date) {
      // this.stDate = getDateFormat(date)
      // this.fiDate = getDateFormat(date)
      return getDateFormat(date)
    },
    init() {
      let toDay = new Date      
      this.stDate = toDay.setDate(toDay.getDate() - 1);
      toDay = new Date
      this.edDate = toDay.setDate(toDay.getDate() + 1);

      this.stDate = dayjs(this.stDate).format('YYYY-MM-DD')
      this.edDate = dayjs(this.edDate).format('YYYY-MM-DD')

      this.getList()

      // console.log('this.$store.state.user.deptCd', this.$store.state.user.deptCd)
      if(this.$store.state.user.deptCd === 'ZN'|| this.$store.state.user.deptCd === 'ZB'){
        this.autDept = 'Y'
      }
      

    }, 
    //Edit Dialog
    editItem (item) {

      if(this.$store.state.user.deptCd === 'ZN'|| this.$store.state.user.deptCd === 'ZB'){
        this.titleInput = 'Input Result'
      }else{
        this.titleInput = 'Input Reject M/H'
      }

      this.modeIndex = this.gridMainList.indexOf(item)
      this.inputResult = Object.assign({}, item)

      this.changeSelect(item)
      // console.log('this.inputResult ', this.inputResult  )
      this.dialog = true
    },
    closeResult () {
      // this.btnRetrieve()
      this.modeIndex = -1
      this.dialog = false

      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Canceled'
    },

    async insResultCnt(e){
      let param = {
            shipNo: e.shipNo,
            inspAct: e.inspAct,
            respCd: e.respCd,
            stDate: e.reqDate,
          }

          // console.log('insResultCntParam', param )
          // getInsResultChk
          await getInsResultChk(param).then(res => {
            // console.log('getInsResultChk', res)

            if(res.list.length > 0) {
              this.insResChk = res.list[0].insResChk
              // console.log('insResultCnt', this.insResChk )
            }
          })
    },

    async insResultDelYN(e) {
        let param = {            
            insRes: e.insResCd,
          }
          // console.log('insResultDelYNParam', param )
       // getInsResultChkDel
          await getInsResultChkDel(param).then(res => {
            // console.log('getInsResultChkDel', res)

              if(res.list.length > 0) {
                this.insResChkDel = res.list[0].insResChkDel
                // console.log('insResultDelYN', this.insResChkDel )

                 // Check select result for Delegation
                if( this.autDept === 'Y'){
                  // console.log('qcYN====>', e.qcYN)

                  if( this.insResChkDel === 'Y' && e.qcYN ==='N'){
                    this.disabledDel = false
                  }else{
                    this.disabledDel = true
                    this.inputResult.insResDe = ''
                  }
                }else{
                  this.disabledDel = true
                }
              }
          })

          // getEvalPoint
          await getEvalPoint(param).then(res => {
            // console.log('getEvalPoint', res)

              if(res.list.length > 0) {
                this.insNRes = res.list[0].evaPnt
                // console.log('getEvalPoint', this.insNRes )
              }
          })
    },

    async loadCondition(e) {
        let param = {
            shipNo: e.shipNo,
            stDate: e.reqDate,
            userId: this.$store.state.user.userId,
            qmPart: e.qmPart,
            div: 'I',

          }  
          // console.log('loadConditionParam', param )       
          // getShipIncharge
          await getShipIncharge(param).then(res => {
            // console.log('getShipIncharge', res)

            if(res.list.length > 0) {
              this.shipIncharge = res.list[0].shipIncharge
              // console.log('getShipIncharge', this.shipIncharge )
            }
          })

          // getCloseYN
          await getCloseYN(param).then(res => {
            // console.log('getCloseYN', res)

            if(res.list.length > 0) {
              this.clsYn = res.list[0].clsYn
              // console.log('getCloseYN', this.clsYn )
            }
          })
    },

    changeSelect(e) {
      // console.log('changeSelect', e)
      this.insResultCnt(e)
      this.insResultDelYN(e)
      this.protectSelect(e)

    },

    protectSelect(e) {

      // console.log('qcYN====>', e.qcYN)
      // console.log('insResCd====>', e.insResCd)
     

      // console.log('protectSelect==>insResCd', e.insResCd)
      // Seclect result for Owner
      if ( this.autDept ==='Y') {
        this.disabledOwner = false
      }else{
        this.disabledOwner = true
      }
      // console.log('disabledOwner', this.disabledOwner)
      //Propotect for Maker 
      // console.log('qmPart', e.qmPart)     
      if( this.$store.state.user.deptCd !=  'ZN'){
        this.disabledMaker = true
      }else{
        if(e.qmPart==='P' && (e.deptCd ==='B0'||e.deptCd ==='B1'||e.deptCd ==='C0')){
          this.disabledMaker = false
        }else{
          this.disabledMaker = true
        }
      }
      // console.log('disabledMaker', this.disabledMaker)

      // Input M/H for Reject result
      if( e.insResCd==='AD'||e.insResCd==='AE'||e.insResCd==='RA'||e.insResCd==='RB'||e.insResCd==='RC'||e.insResCd==='RD'||e.insResCd==='RE'||e.insResCd==='RF') {
        if(this.autDept === 'Y') {
          this.disabledMh = false
        }else{
          if( this.$store.state.user.deptCd !=  e.deptCd) {
            this.disabledMh = true
          }else{
            this.disabledMh = false
          }
        }
      }else{
        this.disabledMh = true
      }

    },

    async saveResult (e) {
      if (this.modeIndex > -1) {
       let params = []
        Object.assign(this.gridMainList[this.modeIndex], e)
          // console.log('#####SaveEdit===>', e)
          // console.log('#####SaveEditInsDate===>', e.insDate)
          // Save function here        
          
          // Check condition before Action
          // console.log('autDept', this.autDept)
          // console.log('autKmgrSec', this.autChkSection.autKmgrSec)

          if(this.autDept ==='Y'){
              if(this.autChkSection.autKmgrSec <= 0 ){
                if(this.autChkSection.autKmgrSec == 0 ){
                  // V.MGR and Eng can not modify
                  if (this.insResChk > 0 && this.insResChkDel === 'Y' ) {
                    this.vToastify(this.$t('Only section Chief can modify result for this ship('+e.qmPartNm+' - Inp. kind: '+e.kindNm+')' ), 'warn')
                    return
                  }else{// Can PIC/Eng accept result, can't change result again: except make request inspection again
                    if (e.kindCd != 'DIM' && this.shipIncharge == 0 ) { 
                      this.vToastify(this.$t('You can not input result for this ship('+e.qmPartNm+' - Inp. kind: '+e.kindNm+')' ), 'warn')
                      return
                    }
                  }

                }else{
                  this.vToastify(this.$t('You do not have authority to change result for this ship('+e.qmPartNm+' - Inp. kind: '+e.kindNm+')' ), 'warn')
                  return

                }
              }

              // QM-Accuracy section: Accuracy check before input result (Sub - Block assembly only)
              if (this.autChkSection.autKmgrSec <= 0  && e.kindCd === 'DIM' && this.autDept === 'Y' &&  e.qmPart === 'H' ) {  

                this.vToastify(this.$t('You do not have authority to save Accuracy test item('+e.qmPartNm+' - Inp. kind: '+e.kindNm+')' ), 'warn')
                return
              }   
              
              if (this.autChkSection.autKmgrSec <= 0 && e.kindCd !== 'DIM' && this.autChkSection.autDimSec > 0 ) {  		          
                this.vToastify(this.$t('You only have authority to save Accuracy test item('+e.qmPartNm+' - Inp. kind: '+e.kindNm+')' ), 'warn')
                return
              }

              if (this.clsYn === 'Y' ) {
                this.vToastify(this.$t('Can not save data because inspection of this month is closed'))
                return
              }
              
              if (e.qcYN === 'N') {
                if (e.insResCd ==='AA'||e.insResCd === 'AC'||e.insResCd === 'AD'||e.insResCd === 'AE'||e.insResCd === 'LQ'||e.insResCd === 'RA'||e.insResCd === 'RB'||e.insResCd === 'RC'||e.insResCd === 'RD'||e.insResCd === 'RE'||e.insResCd === 'RF') {                  
                  if ((e.insResDe === null) || e.insResDe === '' ) {
                    if (e.kindCd !== 'DIM') {
                      this.vToastify(this.$t('Please select a Delegation result')) 
                      return
                    }
                  }
            
                }
              }

          }


          params.push({
                    userId: this.$store.state.user.userId,
                    deptCd: this.$store.state.user.deptCd,        
                    reqDate: e.reqDate,
                    insDate: e.insDate,
                    shipNo: e.shipNo,
                    respCd: e.respCd,
                    inspAct: e.inspAct,
                    insRes: e.insResCd,
                    insResDe: e.insResDe,
                    resPaintMK: e.resPaintMK,
                    kindCd: e.kindCd,
                    acQmCfm: e.acQmCfm,
                    qcYN: e.qcYN,
                    mh: e.mh,
                    insNRes: this.insNRes,
                    insNResLQC: this.insNRes,
                    wowAct: e.wowAct=== true?'Y':'N',
                    wclAct: e.wclAct=== true?'Y':'N',
                    qmPart: e.qmPart,
              })
              
              // console.log('#####SaveEditParams===>', params)
              try {
                this.openLoading('searching')

                v80b1020Update(params).then(res => {
                  // console.log('#####v80b1020Update===>', res.body)
                  if(res.body == 'Y'){
                    notify(this.$t('Inspection Result Update is completed.'), 'success', 3000)
                  }else {
                    this.vToastify(this.$t('An error has been occurred while update data :'), 'warn')
                  }
                  this.btnRetrieve()
                  
                })
                    .catch(error => {
                      this.endLoading()
                    })
              }finally {
                this.endLoading()
              }    

      } else {
        this.gridMainList.push(this.inputResult)
      }
      this.closeResult()

      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Data saved'

    },

    //getList
    async getList() {
      try {
          this.openLoading('searching')
          let params = {
            cdDiv: '01',
          }

          let params1 = {
            cdDiv: '18',
          }

          let param = {
            sysCd: '80',//this.$store.state.system.sysCd,
            menuId: this.$route.meta.menu_id,
            userId: this.$store.state.user.userId,
          }
          // console.log('param', param)
          // getAutSaveYN
          await getAutSaveYN(param).then(res => {
            // console.log('getAutSaveYN', res)

            if(res.list.length > 0) {
              this.autSaveYN = res.list[0].saveYn
              // console.log('getAutSaveYN', this.autSaveYN)
            }
          })
          // getAutInspection
          await getAutInspection(param).then(res => {
            // console.log('getAutInspection', res)
            
            if(res.list.length > 0) {
              this.autChkSection = res.list[0]
              // autDimSec, autKmgrSec, autVmgrSec
              // console.log('getAutInspection:', this.autChkSection)
            }
          })

          await getQMPartList(params).then(res => {
            this.qmPartNameList.push('All')
            res.list.forEach(e => {
              this.qmPartNameList.push(e.qmPart + ' : ' + e.qmPartNm)
            });
            this.qmPartName = this.qmPartNameList[0]
          })

          // getShipList
          await getShipList(params).then(res => {
                  this.shipNoList.push('All')
                  res.list.forEach(e => {
                    this.shipNoList.push(e.shipNo)
                  });
                  this.shipNo = this.shipNoList[0]
                })

          // getDepartment         
          if (this.$store.state.user.deptCd !='ZN' && this.$store.state.user.deptCd !='ZB'){
              this.deptNameList.push(this.$store.state.user.deptCd + ' : ' + this.$store.state.user.deptNm)
              this.deptName = this.deptNameList[0]
              this.deptCd = this.$store.state.user.deptCd
          }else{
            await getDeptList(params).then(res => {
                    this.deptNameList.push('All')
                    res.list.forEach(e => {
                      this.deptNameList.push(e.deptCd + ' : ' + e.deptNm)
                    });
                    this.deptName = this.deptNameList[0]
                  })
          }      
          // Owner Result
          await getResultList(params).then(res => {
                let list = []
                res.list.forEach(e => {
                  if(e != null){
                    list.push({insResNm: e.insResCd + ': ' + e.insResNm , insResCd: e.insResCd, resPnt: e.resPnt})
                  } else {
                    list.push({insResNm: '', insResCd: '', resPnt: ''})
                  }
                });
                this.resultInspList = list
                this.resultInsp = this.resultInspList[0]
              }) 
          // Delegation Result
          await getResultList(params1).then(res => {
                let list = []
                res.list.forEach(e => {
                  if(e != null){
                    list.push({insResDeNm: e.insResCd + ': ' + e.insResNm , insResDe: e.insResCd, resPnt: e.resPnt})
                  } else {
                    list.push({insResDeNm: '', insResDe: '', resPnt: ''})
                  }
                });
                this.resultInspDeList = list
                this.resultInspDe = this.resultInspDeList[0]
              })
          // Maker Result (for Painting)
          await getResultList(params).then(res => {
                let list = []
                res.list.forEach(e => {
                  if(e != null){
                    list.push({resPaintMKNm: e.insResCd + ': ' + e.insResNm , resPaintMK: e.insResCd})
                  } else {
                    list.push({resPaintMKNm: '', resPaintMK: ''})
                  }
                });
                this.resultInspPaintMKList = list
              })    

          } finally {
              this.groupList()
              this.endLoading()
          }

    },
    //get Group
    groupList(){
    this.respNameList = []

    let supdeptCd = this.deptName
    supdeptCd = supdeptCd.split(' : ')
    this.deptCd = supdeptCd[0]
    // console.log('######deptCd===>', this.deptCd)

    let params = {
      deptCd: this.deptCd ==='All'?'':this.deptCd,
    }

    getRespList(params).then(res => {
      this.respNameList.push('All')
      res.list.forEach(e => {
        this.respNameList.push(e.respCd + ' : ' + e.respNm)										
      });
      this.respName = this.respNameList[0]
    })
  },        

  async getMainList() {
        try {
            this.openLoading('searching')

            // console.log("#####Result====>", this.resultInsp.resPnt)
            
            let respName = this.respName
                respName = respName.split(' : ')
                this.respCd = respName[0]

            let qmPartName = this.qmPartName
                qmPartName = qmPartName.split(' : ')  
                this.qmPart = qmPartName[0]  
                          
            let params = {
                stDate: this.stDate,
                edDate: this.edDate,
                shipNo: this.shipNo === 'All' ? '' : this.shipNo,
                deptCd: this.deptCd === 'All' ? '' : this.deptCd,
                respCd: this.respCd === 'All' ? '' : this.respCd,
                qmPart: this.qmPart === 'All' ? '' : this.qmPart,
                resCd: !this.resultInsp.insResCd ? '' : this.resultInsp.insResCd,

            }
            
            // console.log('######getMainList===>', params)

            await v80b1020List(params).then(res => {
              let list = []
              // console.log('######v80b1020List===>', res)
                res.list.forEach(e => {
                  list.push({
                    rno: e.rno,
                    shipNo: e.shipNo,
                    unitAMT: e.unitAMT,
                    usdAmt: e.usdAmt,
                    insDateShow: e.insDate + '/ '+ e.insTime,
                    reqDateShow: e.reqDate + '/ '+ e.reqTime,
                    insDate: e.insDate,
                    insTime: e.insTime,
                    reqDate: e.reqDate,
                    reqTime: e.reqTime,
                    deptCd: e.deptCd,
                    deptNm: e.deptNm+ '/ '+ e.respNmeng,
                    respCd: e.respCd,
                    respNmeng: e.respNmeng,
                    itemDesc2: e.itemDesc2 ,
                    wkKind: e.wkKind,
                    lqcEmp: e.lqcEmp,
                    lqcEmpNm: e.lqcEmpNm,
                    kindCd: e.kindCd,
                    kindNm: e.kindNm,
                    insLocShow: e.insLoc + '/ '+ e.insLocNo,
                    insLoc: e.insLoc,
                    insLocNo: e.insLocNo,
                    inspAct: e.inspAct,
                    insResCd: e.insRes===null ? '' : e.insRes,
                    insResDe: e.insResDe===null ? '' : e.insResDe,
                    insNRes: e.insNRes,
                    insNResLQC: e.insNResLQC,
                    airtYN: e.airtYN,
                    tktYN: e.tktYN,
                    dimtRes: e.dimtRes,
                    qmPart: e.qmPart,
                    qmPartNm: e.qmPartNm,
                    wowShow: e.wow==='Y'? true:false,
                    wclShow: e.wcl==='Y'? true:false,
                    wow: e.wow,
                    wcl: e.wcl,
                    wowAct: e.wowAct==='Y'? true:false,
                    wclAct: e.wclAct==='Y'? true:false,
                    qcYN: e.qcYN,
                    acQmCfm: e.acQmCfm,
                    resEmp: e.resEmp,
                    resEmpNm: e.resEmpNm,
                    resDate: e.resDate,
                    resEmpMod: e.resEmpMod,
                    resDateMod: e.resDateMod,
                    mhEmp: e.mhEmp,
                    mhDate: e.mhDate,
                    cmtCfmDte: e.cmtCfmDte,
                    resPaintMK: e.resPaintMK===null ? '' : e.resPaintMK,
                    rsnCD: e.rsnCD,
                    owner: e.owner,
                    classNm: e.classNm,
                    locNm: e.locNm,
                    locNoNm: e.locNoNm,
                    success: e.success,
                    massage: e.massage,
                    mh: e.mh,
                    mact: e.mact,
                    // mhReject: e.mh+'/ $'+e.usdAmt,
                  })
                  
                });

                this.gridMainList = list
                this.listSize = list.length

                if (this.listSize > 0){
                  this.panel = []
                }
                // console.log('######listSize===>', this.listSize)
            })

        } finally {
            this.endLoading()
        }
    },

  getColor (value) {
      if (value > 400) return 'red'
      else if (value > 200) return 'orange'
      else return 'green'
  },  

},

};
</script>
<style >

/* Start button invert-colors */
.v-btn--fab.v-size--default.v-btn--absolute.v-btn--top {
    top: 10px;
}

.v-btn--fab.v-size--default {
    height: 45px;
    width: 45px;
}

.v-btn--absolute.v-btn--right, .v-btn--fixed.v-btn--right {
    right: 40px;
}

/* End button invert-colors */

.v-expansion-panel-header {
    align-items: center;
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
    display: flex;
    font-size: 0.9375rem;
    line-height: 0.5;
    min-height: 40px;
    outline: none;
    padding: 10px 10px;
    position: relative;
    transition: 0.3s min-height cubic-bezier(0.25, 0.8, 0.5, 1);
    width: 100%;
    background: silver;
}

.v-expansion-panel--active > .v-expansion-panel-header {
    min-height: 40px;
}

.v-expansion-panel-content__wrap {
    padding: 0 4px 4px;
    flex: 1 1 auto;
    max-width: 100%;
}
/* height for each row */
.v-data-table > .v-data-table__wrapper .v-data-table__mobile-row {
    height: initial;
    min-height: 30px;
}

/* Size font */
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    font-size: 10pt;
    height: 30px;
}

.v-dialog > .v-card > .v-card__text {
    padding: 0 4px 10px;
}

.container {
    width: 100%;
    padding: 2px;
    margin-right: auto;
    margin-left: auto;
}

.v-card__subtitle, .v-card__text {
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 0.5rem;
    letter-spacing: 0.0071428571em;
}

.col-xl, .col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1, .col-lg, .col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1, .col-md, .col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1, .col-sm, .col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1, .col, .col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1 {
    width: 100%;
    padding: 10px;
}


</style>
